import React, { useEffect, useState } from "react";
import { Col, Card, Modal, Form, Button } from "react-bootstrap";
import Header from "../Common/Header";
import RecentProfileList from "./RecentProfile/RecentProfileList";
import Searchfield from "../Common/Searchfield";
import { connect } from "react-redux";
import useSearch from "../../hooks";
import _ from "lodash";
import { fetchS3ProfileNames, importProfile, importProfileFromS3 } from "../../../api";
import { useQuery } from "react-query";
import { ClipLoader } from "react-spinners";
import { checkForAPISuccess, showErrorToast, showInfoToast, showSuccessToast } from "../../../Common/commonFunctions";
import { ADD_IMPORTED_PROFILE } from "../../../store/actions";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { RESPONSE_NO_RECORDS_FOUND_CODE, RESPONSE_NO_S3_FILES_FOUND_CODE } from "../../../Common/constants";

const ProfileList = (props) => {

	const [utils, setUtils] = useState({
		showSearchField: false, profileLocation: "", profileName: "", csvFile: "", showNoS3ProfileMsg: false,
		showCsvImportPopup: false, errors: [], isS3Import: true, s3ProfileNames: [], selectedS3ProfileName: ""
	});
	const useQueryConfiguration = {
        enabled: false, retry: false, retryOnMount: false,
        refetchOnMount: false, refetchOnWindowFocus: false
    }

	const manualProfileImport = async () => {
		let formData = new FormData();
		formData.append('csvFile', utils.csvFile);
		formData.append('profileName', utils.profileName);
		formData.append('customerName', props.title)
		formData.append('profileLocation', utils.profileLocation)
		const response = await importProfile(formData);
		return response?.data;
	}

	const getProfileNames = async () => {
		const response = await fetchS3ProfileNames(props.title);
		return response?.data;
	};

	const importProfileViaS3 = async () => {
		const response = await importProfileFromS3({
			profileName: utils.selectedS3ProfileName,
			customerName: props.title,
			profileLocation: utils.profileLocation
		});
		return response?.data;
	}
	
	const importProfileViaS3Query = useQuery("import-profile-s3", importProfileViaS3, useQueryConfiguration);
	const importProfileQuery = useQuery("import-profile-manual", manualProfileImport, useQueryConfiguration);
	const getProfileNamesQuery = useQuery("get-profile-names", getProfileNames, useQueryConfiguration);

	const response = useSearch();
	const onSearchClear = () => response.clearValue()
	const onSearchChange = (e) => response.setSearchValue(e.target.value)
	const clearState = () => setUtils({
		...utils, showCsvImportPopup: false, csvFile: "", profileLocation: "", showNoS3ProfileMsg: false,
		profileName: "", errors: [], isS3Import: true, s3ProfileNames: [], selectedS3ProfileName: ""
	});

	const handleImportButtonDisability = () => {
		return getProfileNamesQuery.isFetching || importProfileQuery.isFetching || importProfileViaS3Query.isFetching ?
			true : !_.isEmpty(utils.errors) ?
				true : utils.isS3Import ?
					_.isEmpty(utils.selectedS3ProfileName) :
						_.isEmpty(utils.csvFile?.name) || _.isEmpty(utils.profileName)
	}

	const handleImportIconClick = () => {
		setUtils({ ...utils, showCsvImportPopup: true, isS3Import: true });
		getProfileNamesQuery.refetch();
	}

	const handleImportResponse = (response) => {
		if(response.isSuccess && checkForAPISuccess(response?.data?.statusCode)) {
			if(!_.isEmpty(response?.data?.data?.profileId)) {
				showSuccessToast('Profile imported successfully');
				clearState();
				props.addImportedProfile(response?.data?.data);
			}
			else if(!_.isEmpty(response?.data?.data?.errors)) {
				setUtils({ ...utils, profileName: '', profileLocation: '', csvFile: '', errors: response?.data?.data?.errors });
			}
		}
		else if(response?.data?.statusCode === RESPONSE_NO_S3_FILES_FOUND_CODE) {
			showInfoToast('No marriage file found inside the selected profile', 7000);
		}
		else {
			setUtils({ ...utils, profileLocation: '', profileName: '', csvFile: '' });
			showErrorToast("Failed to import");
		}
	}

	const hanldeProfileNamesViaS3Response = (response) => {
		if(response.isSuccess && checkForAPISuccess(response?.data?.statusCode)) {
			setUtils({ ...utils, s3ProfileNames: response?.data?.data });
		}
		else if(response?.data?.statusCode === RESPONSE_NO_RECORDS_FOUND_CODE) {
			setUtils({ ...utils, showNoS3ProfileMsg: true });
		}
		else {
			showErrorToast("Failed to fetch profile names for selected customer from S3");
		}
	}

	useEffect(() => {
		if(importProfileQuery.isFetched) {
			handleImportResponse(importProfileQuery);
			importProfileQuery.remove();
		}
		else if(importProfileViaS3Query.isFetched) {
			handleImportResponse(importProfileViaS3Query);
			importProfileViaS3Query.remove();
		}
		else if(getProfileNamesQuery.isFetched) {
			hanldeProfileNamesViaS3Response(getProfileNamesQuery);
			getProfileNamesQuery.remove();
		}
	}, [importProfileQuery.isFetched, importProfileViaS3Query.isFetched, getProfileNamesQuery.isFetched]);	

	return (
		<>
			<Col md={12} sm={12} xs={12} className={"custom-cards mobile-view p-0"}>
				<Card style={{ height: "100%" }}>
					<Header
						title={props.title}
						iconPosition="justify-content-end"
						iconProps={[
							{
								toolTipKEy: "Import",
								toolTipValue: "Import",
								icon: "feather icon-download",
								onClickHandler: () => handleImportIconClick(),
								showIcon: true,
								cursor: "pointer",
							},
							{
								toolTipKEy: "Search",
								toolTipValue: "Search",
								icon: "feather icon-search",
								onClickHandler: () => setUtils({ ...utils, showSearchField: !utils.showSearchField }),
								showIcon: true,
								cursor: "pointer",
							},
						]}
					/>
					{
						utils.showSearchField &&
							<Searchfield inputValue={response.searchValue} inputChange={(e) => onSearchChange(e)} inputClear={onSearchClear} />
					}
					<RecentProfileList selectedCustomerId={props.selectedCustomerId} useSearch={response} />
					<Modal
						onHide={() => clearState()}
						backdrop="static"
						show={utils.showCsvImportPopup}
					>
						<Modal.Header closeButton>
							<h5 className="font-weight-bold">Import Profile</h5>
						</Modal.Header>
						<Modal.Body>
							<div className="my-3">
								{
									importProfileQuery.isFetching || getProfileNamesQuery.isFetching || importProfileViaS3Query.isFetching ?
										<div className="text-center">
											<ClipLoader color="#075978" />
										</div>
											:
										_.isEmpty(utils.errors) ?
											<>
												<div className="d-flex justify-content-around">
													<Form.Group className="d-flex">
														<Form.Check
															checked={utils.isS3Import} id={"s3-import-radio"} type="radio"
															onChange={e => setUtils({ ...utils, isS3Import:  e.target.checked })}
														/>
														<Form.Label
															className="font-weight-bold cursor-pointer"
															htmlFor={"s3-import-radio"}
														>
															{"Import from S3"}
														</Form.Label>
													</Form.Group>

													<Form.Group className="d-flex">
														<Form.Check
															checked={!utils.isS3Import} id={"local-import-radio"} type="radio"
															onChange={e => setUtils({ ...utils, isS3Import: !e.target.checked })}
														/>
														<Form.Label
															className="font-weight-bold cursor-pointer"
															htmlFor={"local-import-radio"}
														>
															{"Import manually"}
														</Form.Label>
													</Form.Group>
												</div>

												{
													utils.isS3Import ?
														<>
															<Form.Group>
															{
																!_.isEmpty(utils.s3ProfileNames) &&
																	<select 
																		onChange={e => setUtils({ ...utils, selectedS3ProfileName: e.target.value })} 
																		defaultValue={!_.isEmpty(utils.selectedS3ProfileName) ? utils.selectedS3ProfileName : "1"}
																		className="edit-dropdown w-100" disabled={_.isEmpty(utils.s3ProfileNames)}
																	>
																		{
																			<>
																				<option value={"1"} disabled>Select a profile name</option>
																				{
																					utils.s3ProfileNames.map(
																						profile => <option key={profile} value={profile}>{profile}</option>
																					)
																				}
																			</>
																		}
																</select>
															}
															{
																utils.showNoS3ProfileMsg &&
																	<div className="text-center color-red font-weight-bold">No profile found in S3 for selected customer.</div>
															}
															</Form.Group>
															<Form.Group>
																<Form.Label>Location</Form.Label>
																<Form.Control  onChange={e => setUtils({ ...utils, profileLocation: e.target.value })} />
															</Form.Group>
														</>
															:
														<>
															<Form.Group className="my-3">
																<>
																	<Form.Label>Name</Form.Label>
																	<Form.Control onChange={e => setUtils({ ...utils, profileName: e.target.value })} />
																</>
															</Form.Group>

															<Form.Group>
																<>
																	<Form.Label>Location</Form.Label>
																	<Form.Control onChange={e => setUtils({ ...utils, profileLocation: e.target.value })} />
																</>
															</Form.Group>

															<Form.Group>
																<Form.Control
																	id="file-input"
																	onChange={(e) => setUtils({ ...utils, csvFile: e.target.files[0] })}
																	className="my-4"
																	type="file"
																	accept=".csv"
																/>
															</Form.Group>
														</>
												}
											</>
												:
											<PerfectScrollbar style={{ display: "flex", flexDirection: "column", maxHeight: "40vh" }}>
												{
													utils.errors.map(error => {
														return (
															<div className="my-2">
																{error}
															</div>
														)
													})
												}
											</PerfectScrollbar>
								}
							</div>
						</Modal.Body>
						<Modal.Footer>
							<Button
								disabled={handleImportButtonDisability()}
								onClick={() => utils.isS3Import ? importProfileViaS3Query.refetch() :importProfileQuery.refetch()}
							>
								Import
							</Button>
						</Modal.Footer>
					</Modal>
				</Card>
			</Col>
		</>
	);
};

const mapStateToProps = (state) => {
  return {
    menu: state.menu,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    menuset: () => dispatch({ type: "PROFILE" }),
    recentMenu: () => dispatch({ type: "CUSTOMER" }),
	addImportedProfile: (profileInfo) => dispatch({ type: ADD_IMPORTED_PROFILE, payload: profileInfo })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileList);